import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeColor, GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { TranslateModule } from '@ngx-translate/core';
import {
  CrmFieldService,
  NonStandardExternalIDs,
  ObjectType,
  ProfileHeaderComponentInterface,
} from '@galaxy/crm/static';
import { CrmObjectInterface } from '@vendasta/crm';

@Component({
  selector: 'crm-nps-badge-reputation',
  imports: [CommonModule, GalaxyBadgeModule, TranslateModule],
  templateUrl: './nps-badge.component.html',
  styleUrl: './nps-badge.component.scss',
})
export class NpsBadgeComponent implements ProfileHeaderComponentInterface {
  @Input() crmObjectType: ObjectType | undefined;

  private _crmObject?: CrmObjectInterface;
  @Input()
  set crmObject(value: CrmObjectInterface) {
    this._crmObject = value;
    this.updateNpsBadge();
  }
  get crmObject(): CrmObjectInterface | undefined {
    return this._crmObject;
  }

  netPromoterScore: string | null = null;
  npsScoreBadgeColor: BadgeColor | null = null;

  constructor(private crmFieldService: CrmFieldService) {}

  private updateNpsBadge() {
    const netPromoterScoreFieldId = this.crmFieldService.getFieldId(NonStandardExternalIDs.NetPromoterScore);
    const netPromoterScoreField = this._crmObject?.fields?.find((f) => f.fieldId === netPromoterScoreFieldId);
    this.netPromoterScore = netPromoterScoreField?.integerValue?.toString() || null;
    this.npsScoreBadgeColor = this.netPromoterScore ? this.getColor(this.netPromoterScore) : null;
  }

  getColor(score: string): BadgeColor {
    if (score === '9' || score === '10') {
      return 'green' as BadgeColor;
    } else if (score >= '7') {
      return 'yellow' as BadgeColor;
    } else {
      return 'red' as BadgeColor;
    }
  }
}
